import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../index";

// Base selector
const selectUIState = (state: RootState) => state.ui;

export const selectors = {
  selectCurrentStep: createSelector(
    selectUIState,
    (state) => state.currentStep,
  ),

  selectIsSidebarOpen: createSelector(
    selectUIState,
    (state) => state.isSidebarOpen,
  ),

  selectSelectedSystem: createSelector(
    selectUIState,
    (state) => state.selectedSystem,
  ),

  selectValidationErrors: createSelector(
    selectUIState,
    (state) => state.validationErrors,
  ),

  selectValidationWarnings: createSelector(
    selectUIState,
    (state) => state.validationWarnings,
  ),
} as const;
